const arrowKeys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];

export function findGridNeighbor(
  layout: Map<string, { row: number; col: number }>,
  currentId: string,
  key: string
) {
  if (!arrowKeys.includes(key)) return null;

  const curr = layout.get(currentId);
  if (!curr) return null;

  const entries = [...layout.entries()];
  const fixedAxis = ["ArrowLeft", "ArrowRight"].includes(key) ? "row" : "col";
  const moveAxis = fixedAxis === "row" ? "col" : "row";
  const ascending = ["ArrowRight", "ArrowDown"].includes(key);

  const candidates = entries.filter(
    ([, p]) =>
      p[fixedAxis] === curr[fixedAxis] &&
      (ascending ? p[moveAxis] > curr[moveAxis] : p[moveAxis] < curr[moveAxis])
  );

  candidates.sort((a, b) =>
    ascending
      ? a[1][moveAxis] - b[1][moveAxis]
      : b[1][moveAxis] - a[1][moveAxis]
  );

  return candidates[0]?.[0];
}
